import FormattedMessage from 'I18n/components/FormattedMessage';
import { Image } from 'foundations-components/transitional/components/Image';
import { Flex } from 'foundations-components/components/Flex';
import { WarningIcon } from 'foundations-assets';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MessagePreviewAttachments = ({
  additionalAttachmentCount = 0,
  hasMissingAttachment = false,
  Icon,
  url
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [url ? /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      alignItems: "center",
      flexShrink: "0",
      overflow: "clip",
      alignSelf: "center",
      marginInlineStart: "250",
      inlineSize: "35px",
      blockSize: "35px",
      backgroundColor: "icon-core-on-fill-default",
      borderRadius: "200",
      children: /*#__PURE__*/_jsx(Image, {
        objectFit: "cover",
        src: url,
        role: "img"
      })
    }) : Icon && /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      alignItems: "center",
      flexShrink: "0",
      overflow: "clip",
      alignSelf: "center",
      marginInlineStart: "250",
      inlineSize: "35px",
      blockSize: "35px",
      backgroundColor: "icon-core-on-fill-default",
      borderRadius: "200",
      children: /*#__PURE__*/_jsx(Icon, {})
    }), hasMissingAttachment ? /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      alignItems: "center",
      flexShrink: "0",
      overflow: "clip",
      alignSelf: "center",
      marginInlineStart: "250",
      inlineSize: "35px",
      blockSize: "35px",
      backgroundColor: "icon-core-on-fill-default",
      borderRadius: "200",
      children: /*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-message-history.attachments.unavailableAttachment"
        }),
        children: /*#__PURE__*/_jsx(WarningIcon, {
          size: "600"
        })
      })
    }) : additionalAttachmentCount > 0 && /*#__PURE__*/_jsx(Flex, {
      justifyContent: "center",
      alignItems: "center",
      flexShrink: "0",
      overflow: "clip",
      alignSelf: "center",
      marginInlineStart: "250",
      inlineSize: "35px",
      blockSize: "35px",
      backgroundColor: "icon-core-on-fill-default",
      borderRadius: "200",
      children: /*#__PURE__*/_jsx(Text, {
        typography: "body-300",
        color: "icon-interactive-default",
        children: `+${additionalAttachmentCount}`
      })
    })]
  });
};
MessagePreviewAttachments.displayName = 'MessagePreviewAttachments';
export default MessagePreviewAttachments;